import React, { useState } from "react";
import Tag from "./Tag.v1";
import { getLanguageField } from '../../utils/language';

type ITag = {
    name: string;
    translations: Array<{
        languages_code: { code: string };
        label: string;
    }>;
}

type IProps = {
    tags: Array<ITag>,
    language: string,
    size?: "lg" | "sm" | undefined;
    corners?: "full-rounded" | "rounded" | "square" | undefined; 
    type?: "primary" | "secondary" | undefined;
}

const MAX_VISIBLE_TAGS = 5;

export default function Tags(props: IProps) {
    const [expanded, setExpanded] = useState(false);
    // 5 tags: show all 5. 6+: show 4 + "+X attributes"
    const hasOverflow = props.tags.length > MAX_VISIBLE_TAGS;
    const visibleWhenCollapsed = MAX_VISIBLE_TAGS - 1;
    const visibleTags = expanded
        ? props.tags
        : (hasOverflow ? props.tags.slice(0, visibleWhenCollapsed) : props.tags);
    const remainingCount = props.tags.length - visibleWhenCollapsed;

    const handleToggleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setExpanded((prev) => !prev);
    };

    const overflowTag = (
        <Tag
            size={props.size}
            text={expanded ? "− hide" : `+${remainingCount} attributes`}
            corners={props.corners}
            type={props.type}
        />
    );

    return (
        <>
            {visibleTags.map((tag, index) => (
                <Tag
                    key={index}
                    size={props.size}
                    text={getLanguageField(tag.translations, props.language, "label") as string}
                    corners={props.corners}
                    type={props.type}
                />
            ))}
            {hasOverflow && (
                <span
                    role="button"
                    tabIndex={0}
                    onClick={handleToggleClick}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            e.stopPropagation();
                            setExpanded((prev) => !prev);
                        }
                    }}
                    className="inline-block cursor-pointer"
                >
                    {overflowTag}
                </span>
            )}
        </>
    );
}